import apiClient from 'api/config/apiClient'

export default {
  getWebformSubmissions(payload) {
    return apiClient.request('webform_submission', payload)
  },
}
